import { AccountRepository } from '../Repositories/AccountRepository';

export class ResetPasswordUseCase {
  constructor(private repo: AccountRepository) {}

  execute(accountId: number, newPassword: string): Promise<void> {
    if (!newPassword || newPassword.trim().length < 4) {
      throw new Error('비밀번호는 최소 4자 이상이어야 합니다.');
    }
    
    return this.repo.resetPassword(accountId, newPassword);
  }
} 